// The preview access code is deliberately session-scoped: it survives a refresh but dies
// with the browser tab, so a hidden venue isn't revealed to the next visitor on a shared
// or kiosk machine. The URL (?ac=) is the durable carrier; this is the refresh-survival
// layer. Kept out of the localStorage 'state' blob for that reason - see index.tsx.

const ACCESS_CODE_KEY = 'zl_ac';

export const readAccessCode = (): string | undefined => {
    try {
        return sessionStorage.getItem(ACCESS_CODE_KEY) ?? undefined;
    } catch {
        // sessionStorage access throws outright in some private-browsing and kiosk
        // configurations - the URL remains the carrier in that case
        return undefined;
    }
};

export const writeAccessCode = (accessCode: string | undefined): void => {
    try {
        if (accessCode) {
            sessionStorage.setItem(ACCESS_CODE_KEY, accessCode);
        } else {
            sessionStorage.removeItem(ACCESS_CODE_KEY);
        }
    } catch {
        // as above - storage unavailable, nothing we can do
    }
};
